import { render, staticRenderFns } from "./tel-settle-case-manage.vue?vue&type=template&id=48c9e688&scoped=true"
import script from "./tel-settle-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-settle-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9e688",
  null
  
)

export default component.exports